import React from 'react';
import { Toast, ToastContainer } from 'react-bootstrap';

interface ToasterProps {
  show: boolean;
  message?: string;
  headerText: string;
  position?: any;
  bg?: string;
  handleClose: () => void;
}

const Toaster = ({
  show,
  headerText,
  message,
  handleClose,
  bg,
  position = 'top-end',
}: ToasterProps) => {
  return (
    <ToastContainer
      style={{ zIndex: '99999' }}
      position={position}
      className="p-3 pt-4 mt-5 position-fixed"
      role="toaster">
      <Toast
        onClose={() => handleClose()}
        show={show}
        delay={5000}
        autohide
        bg={bg}>
        <Toast.Header>
          {bg == 'success' && (
            <i className="eha-check-circle fs-5 text-success ms-n1 me-1"></i>
          )}
          {bg == 'warning' && (
            <i className="eha-level4 fs-5 text-warning ms-n1 me-1"></i>
          )}
          {bg == 'danger' && (
            <i className="eha-level4 fs-5 text-danger ms-n1 me-1"></i>
          )}
          <strong className="me-auto">{headerText}</strong>
        </Toast.Header>
        {message && <Toast.Body>{message}</Toast.Body>}
      </Toast>
    </ToastContainer>
  );
};

export default Toaster;
